import React from 'react';
import rehypeSlug from 'rehype-slug';
import { ArtifactoryMarkdown } from '../artifactory/ArtifactoryMarkdown';

interface Props {
  content: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

/**
 * Thin wrapper around ArtifactoryMarkdown that injects rehype-slug for
 * heading anchor IDs. Used by the Documentation page so cross-doc
 * deep-links (/docs/<slug>#anchor) actually have something to scroll to.
 *
 * Existing chat / artifact viewers / send-to / pulse history surfaces
 * keep using ArtifactoryMarkdown directly with no extraRehypePlugins —
 * preserving their current behavior (no IDs on chat-bubble headings,
 * no ID-collision risk across bubbles, no unwanted scroll-on-mount).
 */
export const DocsMarkdown: React.FC<Props> = ({ content, size = 'medium', className }) => (
  <ArtifactoryMarkdown
    content={content}
    size={size}
    className={className}
    extraRehypePlugins={[rehypeSlug]}
  />
);
